import isUndefined from 'lodash/isUndefined';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '@spothero/ui/carousel';
import CarouselSlide from '@spothero/ui/carousel-slide';
import CarouselSlides from '@spothero/ui/carousel-slides';
import Image from 'common/image/Image';

const SpotImages = ({
    className,
    images,
    alt,
    lazyLoad,
    width,
    height,
    showArrows,
    showDots,
    showPageNumbers,
    transition,
}) => {
    const classes = classNames('SpotImages', className);

    return (
        <div className={classes}>
            {images.length > 0 && (
                <Carousel
                    transition={transition}
                    showArrows={showArrows}
                    showDots={showDots}
                    showPageNumbers={showPageNumbers}
                    lazyLoad={lazyLoad}
                    preload={false}
                >
                    <CarouselSlides>
                        {images.map((image, index) => {
                            const imgProps = {
                                width,
                                height,
                                ...(!isUndefined(image.id)
                                    ? {
                                          index,
                                          alt,
                                          cloudinaryImageId: image.id,
                                      }
                                    : {
                                          'data-index': index,
                                          src: image.src,
                                          alt: image.alt,
                                      }),
                            };

                            return (
                                <CarouselSlide key={index}>
                                    <Image {...imgProps} />
                                </CarouselSlide>
                            );
                        })}
                    </CarouselSlides>
                </Carousel>
            )}
        </div>
    );
};

SpotImages.propTypes = {
    className: PropTypes.string,
    images: PropTypes.array.isRequired,
    alt: PropTypes.string,
    lazyLoad: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    showArrows: PropTypes.bool,
    showDots: PropTypes.bool,
    showPageNumbers: PropTypes.bool,
    transition: PropTypes.oneOf(['none', 'slide', 'fade']),
};

SpotImages.defaultProps = {
    lazyLoad: true,
    width: 320,
    height: 220,
    showPageNumbers: true,
    transition: 'slide',
};

export default SpotImages;
